import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MGetAllTagsResponse } from 'src/app/pages/homepage/homepage.module';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from 'src/app/pages/product-detail-updated/product-detail-updated.module';
import { MGetPriceListRequest } from 'src/app/pages/product-type-beauty/product-type-beauty.module';
import { MGetAllShopAllModuleDataResponse, MGetBrandByInitialsRequest, MGetBrandResponse, MGetProductRequest, MGetProductResponse } from 'src/app/pages/product/product.module';
import { MCommonListModalRequest, UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsShopallService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Date : 08-06-23
   * Method : This method is used to get category , subcategory , skin concern and skin type by category id.
   * @param category_id : This param is value of category id to pass in api to get category , subcategory , skin concern and skin type
   * @returns 
   */
  getAllModuleDataOfShopAll(category_id?: any): Observable<MGetAllShopAllModuleDataResponse> {
    var url = UtilsService.BASE_URL + UtilsService.GETCATEGORYSUBCATEGORYSKINTYPECONCERNBYCATEGORYID;
    if (category_id) {
      const categoryId = "categoryIds=" + category_id;
      url = UtilsService.BASE_URL + UtilsService.GETCATEGORYSUBCATEGORYSKINTYPECONCERNBYCATEGORYID + '?' + categoryId;
    }
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<MGetAllShopAllModuleDataResponse>(url, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getLeafCategoryList(subCategoryId?: any): Observable<any> {
    var url = UtilsService.BASE_URL + UtilsService.LEAFCATEGORYLIST+'?isAllowInactive='+false
    if (subCategoryId) {
      url = UtilsService.BASE_URL + UtilsService.LEAFCATEGORYLIST + '?subcategoryids=' + subCategoryId+'&isAllowInactive='+false;
    }
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(url, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
   * Date : 08-06-23
   * Method : This method is used to get category , subcategory , skin concern and skin type by category id.
   * @param category_id : This param is value of category id to pass in api to get category , subcategory , skin concern and skin type
   * @returns 
   */
  getAllModuleDataOfShopAllWithoutCategory(): Observable<MGetAllShopAllModuleDataResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<MGetAllShopAllModuleDataResponse>(UtilsService.BASE_URL + UtilsService.GETCATEGORYSUBCATEGORYSKINTYPECONCERNBYCATEGORYID, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date : 08-06-23
  * Method : This method is used to get products by category , subcategory , skin concern , skin type.
  * @param mGetProductRequest : This param is an object to pass the filter params
  * @returns 
  */
  getAllProductByParameters(mGetProductRequest: MGetProductRequest): Observable<MGetProductResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MGetProductResponse>(UtilsService.BASE_URL + UtilsService.GETPRODUCTBYPARAMETERS, mGetProductRequest, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getAllProductByTags(mGetProductRequest: MGetProductRequest): Observable<MGetProductResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MGetProductResponse>(UtilsService.BASE_URL + UtilsService.GETPRODUCTBYTAGS+'?tags='+mGetProductRequest, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  updateProductReview(updateProductReviewData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.UPDATEPRODUCTREVIEW, updateProductReviewData, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getPriceList(mGetPriceListRequest: MGetPriceListRequest): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETPRICELIST, mGetPriceListRequest, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date : 08-06-23
  * Method : This method is used to get all brands
  * @param mCommonListModal : This param is an object to pass the filter params having take ,skip with pagination
  * @returns 
  */
  getAllBrand(mCommonListModal: MCommonListModalRequest): Observable<MGetBrandResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MGetBrandResponse>(UtilsService.BASE_URL + UtilsService.GETALLBRAND, mCommonListModal, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date : 08-06-23
  * Method : This method is used to get all brands By Name
  * @param mGetProductRequest : This param is an object to pass name by search 
  * @returns 
  */
  getBrandByInitials(mGetBrandByInitialsRequest: MGetBrandByInitialsRequest): Observable<MGetBrandResponse> {
    return this.httpClient.post<MGetBrandResponse>(UtilsService.BASE_URL + UtilsService.GETBRANDBYSEARCHBRANDNAMEBYINITIALS + '?name=' + mGetBrandByInitialsRequest.name + '&isInitials=' + mGetBrandByInitialsRequest.isInitials, '').pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getAllSubCategory(mCommonListModal: MCommonListModalRequest): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETALLSUBCATEGORY, mCommonListModal, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getGender(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<any>(UtilsService.BASE_URL + UtilsService.GETGENDER, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
 * Date : 08-06-23
 * Method : This method is used to get all cart products of user by id
 * @param userId : This param id of user logged in 
 * @returns 
 */
  getCartList(userId: any): Observable<MAddUpdateCartModuleResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<MAddUpdateCartModuleResponse>(UtilsService.BASE_URL + UtilsService.GETCARTBYUSER + '?userId=' + userId, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
* Date : 08-06-23
* Method : This method is used to remove all cart products of user by id
* @param userId : This param id of user logged in 
* @returns 
*/
  removeCartList(userId: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<any>(UtilsService.BASE_URL + UtilsService.REMOVECARTBYUSER + '?userId=' + userId, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
 * Date : 08-06-23
 * Method : This method is used to add or remove cart product
 * @param mAddUpdateCartModule : This param is an object to pass to add / remove product from cart
 * @returns 
 */
  addRemoveProductFromCart(mAddUpdateCartModule: MAddUpdateCartModule): Observable<MAddUpdateCartModuleResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MAddUpdateCartModuleResponse>(UtilsService.BASE_URL + UtilsService.MANAGECARTBYUSER, mAddUpdateCartModule, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date : 08-06-23
  * Method : This method is used to update product count.
  * @param productId : This param is product ID
  * @returns 
  */
  addProductClickCount(productId: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.ADDPRODUCTCLICK + "?productId=" + productId, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  addProductReview(productData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.ADDPRODUCTREVIEW, productData, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }
  updateProductReviewPage(productData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.UPDATEPRODUCTREVIEWPAGE,productData, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getAllWebsiteconfigurations(mCommonListModal: MCommonListModalRequest): Observable<MGetBrandResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MGetBrandResponse>(UtilsService.BASE_URL + UtilsService.WEBSITECONFIGURATION, mCommonListModal, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getAllProductReviews(mCommonListModalRequest: MCommonListModalRequest): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETALLPRODUCTREVIEW, mCommonListModalRequest, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  getProductReviewByProductId(productId: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETPRODUCTREVIEWBYPRODUCTID + '?product_id=' + productId, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
* Date : 22-11-23
* Method : This method is used to get all products.
* @returns 
*/
  getAllTags(): Observable<MGetAllTagsResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETALLTAG, httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }
}
